'use client';

import { httpMethods } from '@/constants/http-methods';
import { commonFetch, CommonFetchResponse, createCommonDefaultPagedData } from '@/utils/common-fetch';
import { EmailSubscription, EmailSubscriptionData, PagedListOfEmailSubscription } from '@cinemark/profile-api-client';

class EmailSubscriptionApiService {
  private readonly guestSubscriptionsUrl = '/papi/guests/subscriptions/emails';
  private readonly subscriptionsUrl = '/papi/profiles/me/subscriptions/emails';

  async createGuestSubscription(email: string, emailSubscriptionData: EmailSubscriptionData): Promise<EmailSubscription> {
    const response = await commonFetch<EmailSubscription>(`${this.guestSubscriptionsUrl}?emailAddress=${encodeURIComponent(email)}`, {
      body: JSON.stringify(emailSubscriptionData),
      method: httpMethods.post,
    });

    return response?.data;
  }

  async subscriptions(): Promise<CommonFetchResponse<PagedListOfEmailSubscription>> {
    const response = await commonFetch<PagedListOfEmailSubscription>(this.subscriptionsUrl);

    if (!response) {
      return createCommonDefaultPagedData<EmailSubscription>();
    }

    return response;
  }

  async createSubscription(emailSubscriptionData: EmailSubscriptionData): Promise<EmailSubscription> {
    const response = await commonFetch<EmailSubscription>(this.subscriptionsUrl, {
      body: JSON.stringify(emailSubscriptionData),
      method: httpMethods.post,
    });

    return response?.data;
  }

  async updateSubscription(emailSubscriptionId: number, emailSubscriptionData: EmailSubscriptionData): Promise<void> {
    await commonFetch(`${this.subscriptionsUrl}/${emailSubscriptionId}`, {
      body: JSON.stringify(emailSubscriptionData),
      method: httpMethods.put,
    });
  }

  async upsertSubscription(emailSubscriptionData: EmailSubscriptionData): Promise<EmailSubscription> {
    const response = await commonFetch<EmailSubscription>(`${this.subscriptionsUrl}/upsert`, {
      body: JSON.stringify(emailSubscriptionData),
      method: httpMethods.post,
    });

    return response?.data;
  }
}

export const emailSubscriptionApiService = new EmailSubscriptionApiService();
